import React, { useEffect, useState } from 'react'
import { Box, Flex, HR } from 'ui/bend'
import { MyPraticeSummary } from './MyPraticeSummary/MyPraticeSummary'
import BuilderSection from '../BuilderSection'
import RecommendationWidget from './RecommendationWidget'
import camelize from 'camelize'
import styled from 'styled-components'

const MainFlex = styled(Flex)`
  display: flex;
  flex-direction: column;

  & > div {
    margin-bottom: 12px;
    &:first-of-type.category-cards {
      margin: 0;
    }
    @media screen and (min-width: 480px) {
      margin-bottom: 24px;
      &:first-of-type.category-cards {
        margin: 12px 0;
      }
    }
    :last-of-type {
      margin: 0;
    }
  }
`

const SchemaSectionRenderer = ({ schema, user, location }) => {
  const [schemaData, setSchemaData] = useState({})

  useEffect(() => {
    const fetchData = async () => {
      if (typeof schema === 'string') {
        try {
          const data = JSON.parse(schema)
          setSchemaData(camelize(data))
        } catch (err) {
          setSchemaData({})
        }
      } else {
        setSchemaData(schema)
      }
    }

    fetchData()
  }, [schema])

  return (
    <MainFlex className='main-flex'>
      {schemaData?.sections?.map((section, index) => (
        <Box
          className={section?.type}
          key={index}
          px={section.fullWidth ? '0' : 'calc(60*(100vw/1440))'}
        >
          {section?.source === 'builder' ? (
            <BuilderSection user={user} {...section} />
          ) : section?.source === 'dev_build' &&
            section?.type === 'my-practice-summary' ? (
            <MyPraticeSummary />
          ) : section?.source === 'dev_build' &&
            section?.type === 'horizontal-line' ? (
            <HR />
          ) : section?.source === 'dev_build' &&
            section?.type === 'recommended-section' ? (
            <RecommendationWidget {...section} location={location} />
          ) : (
            <></> // Default case
          )}
        </Box>
      ))}
    </MainFlex>
  )
}

export default SchemaSectionRenderer
